import React from 'react';
import ScaledImg from '../ScaledImg';
import brochureImg from './img/brochure.png';

export interface BrochureParagraph {
  title: string;
  text: string;
}

interface ProductBrochureSectionProps {
  brochureParagraphs: BrochureParagraph[];
  setBrochureParagraphs: (brochureParagraphs: BrochureParagraph[]) => void;
  mutableParagraphs : boolean
}

const ProductBrochureSection: React.FC<ProductBrochureSectionProps> = ({
  brochureParagraphs,
  setBrochureParagraphs,
  mutableParagraphs
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
    field: 'title' | 'text'
  ) => {
    const newBrochureParagraphs = [...brochureParagraphs];
    newBrochureParagraphs[index][field] = e.target.value;
    setBrochureParagraphs(newBrochureParagraphs);
  };

  const addParagraph = () => {
    if (brochureParagraphs.length < 4) {
      setBrochureParagraphs([...brochureParagraphs, { title: '', text: '' }]);
    }
  };

  const removeParagraph = (index: number) => {
    if (brochureParagraphs.length > 1) {
      const newBrochureParagraphs = brochureParagraphs.filter((_, i) => i !== index);
      setBrochureParagraphs(newBrochureParagraphs);
    }
  };

  return (
    <div>
      <h2>Product Brochure</h2>
      <ScaledImg src={brochureImg} />
      {brochureParagraphs.map((paragraph, index) => (
        <div key={index}>
          <label htmlFor={`paragraph${index + 1}Title`}>Paragraph {index + 1} - title *</label>
          <input
            type="text"
            id={`paragraph${index + 1}Title`}
            value={paragraph.title}
            onChange={(e) => handleChange(e, index, 'title')}
            required
          />
          <label htmlFor={`paragraph${index + 1}Body`}>Paragraph {index + 1} - body *</label>
          <textarea
            id={`paragraph${index + 1}Body`}
            value={paragraph.text}
            onChange={(e) => handleChange(e, index, 'text')}
            required
          />
          {brochureParagraphs.length > 1 && mutableParagraphs && (
            <button type="button" onClick={() => removeParagraph(index)}>Remove Paragraph</button>
          )}
        </div>
      ))}
      {brochureParagraphs.length < 4 && mutableParagraphs && (
        <button type="button" onClick={addParagraph}>Add Paragraph</button>
      )}
    </div>
  );
};

export default ProductBrochureSection;